// Final match statuses match backend SeasonService.FINAL_MATCH_STATUSES.
const FINAL_STATUSES = new Set(['completed', 'forfeited', 'cancelled']);

/**
 * Whether a new season can begin in this league.
 * - Before the first fixtures are created, yes.
 * - After all current season matches are final, yes.
 * - While any current match is unfinished, no.
 *
 * @param {{seasonState?: string, matches?: Array<{status?: string}>}} league
 * @returns {boolean}
 */
export function canBeginSeason(league) {
  if (!league) return false;

  if (league.seasonState === 'active') return false;
  if (['notStarted', 'completed'].includes(league.seasonState)) return true;

  const matches = league.matches;
  if (!Array.isArray(matches)) return false;
  if (matches.length === 0) return true;
  return matches.every((m) => m && FINAL_STATUSES.has(m.status));
}

export function isPreSeason(league) {
  if (!league) return false;
  if (league.seasonState) return league.seasonState === 'notStarted';
  return Array.isArray(league.matches) && league.matches.length === 0;
}

/**
 * Whether "Begin season" must go through the multiplayer start endpoint
 * (which handles the scheduled round-1 kickoff) instead of the legacy
 * generate-fixtures endpoint. True only for the FIRST season of an
 * auto-squad multiplayer league: once matches exist, next-season
 * regeneration uses the legacy flow (odd team counts are handled by bye
 * rounds in the fixture scheduler).
 *
 * @param {{gameMode?: string, autoSquads?: boolean, matches?: Array}} league
 * @returns {boolean}
 */
export function isAutoSquadSeasonLaunch(league) {
  if (
    league?.gameMode === 'multiplayer' &&
    league?.autoSquads === true
  ) {
    return isPreSeason(league);
  }

  return false;
}
